import { Row, StarRating } from "@dgs/core";
import { FC } from "react";
import { EvaluatedFeedbackRatingQuestionResource } from "../types/feedback";

interface Props {
	question: EvaluatedFeedbackRatingQuestionResource;
}
export const CompactFeedbackRatingQuestionEvaluation: FC<Props> = ({ question }) => {
	return (
		<Row $columnGap={1}>
			<span>⌀ {question.evaluation.averageRating.toFixed(1)}</span>
			<StarRating size="small" rating={question.evaluation.averageRating} />
		</Row>
	);
};
